import React, { useEffect, useState } from "react";
import { Send, Search, BellRing } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "../../AuthContext";

const STEPS = [
  "Instalează aplicația Telegram pe telefon (gratuită) și creează-ți cont cu numărul tău.",
  "În Telegram, caută „BotFather” (cu bifă albastră) și apasă Start.",
  "Scrie-i: /newbot → îți cere un nume (ex. „Marioway Alerte”) → apoi un username care se termină în „bot” (ex. marioway_alerte_bot).",
  "BotFather îți trimite un TOKEN (un text lung cu două puncte, ex. 123456789:AAH…). Copiază-l și lipește-l mai jos.",
  "Deschide botul tău nou (link-ul din mesajul BotFather), apasă Start și scrie „salut”.",
  "Apasă aici „Detectează telefonul meu”, apoi „Trimite test”. Gata – vei primi alerte la fiecare mesaj și programare.",
];

export const TelegramSettings = ({ http }) => {
  const [info, setInfo] = useState(null);
  const [token, setToken] = useState("");
  const [busy, setBusy] = useState("");
  const load = () => http.get("/admin/telegram").then((r) => setInfo(r.data)).catch(() => setInfo({ enabled: false }));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const detect = async () => {
    setBusy("detect");
    try {
      const r = await http.post("/admin/telegram/detect", { token: token.trim() });
      toast.success(`Telefon detectat: ${r.data.name || r.data.chat_id}`);
      setToken("");
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(""); }
  };
  const test = async () => {
    setBusy("test");
    try { await http.post("/admin/telegram/test"); toast.success("Mesaj de test trimis – verifică Telegram!"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(""); }
  };

  if (!info) return <p className="text-[#4A4A4A]">Se încarcă…</p>;
  return (
    <div className="grid lg:grid-cols-12 gap-6" data-testid="admin-telegram">
      <div className="lg:col-span-7 soft-card p-6">
        <div className="flex items-center gap-2 font-bold text-[#002B7F]"><BellRing size={16} className="text-[#F37021]" /> Alerte pe telefon prin Telegram</div>
        <div className={`mt-3 inline-block rounded-full px-3 py-1 text-[12px] font-bold ${info.enabled ? "bg-[#E8F5EC] text-[#1F5D2D]" : "bg-[#FFF4E5] text-[#A16207]"}`} data-testid="telegram-status">
          {info.enabled ? `Activ · chat ${info.chat_id} · token …${info.token_hint}` : "Neconfigurat"}
        </div>
        <label className="block mt-5">
          <span className="text-[13px] font-bold text-[#002B7F]">Token-ul botului (de la BotFather)</span>
          <input className="input-field mt-2 font-mono text-[13px]" placeholder="123456789:AAH…" value={token} onChange={(e) => setToken(e.target.value)} data-testid="telegram-token" />
        </label>
        <div className="mt-4 flex flex-wrap gap-2">
          <button type="button" onClick={detect} disabled={busy || token.trim().length < 10} className="btn-orange text-[13px] px-4 py-2 disabled:opacity-50" data-testid="telegram-detect">
            <Search size={14} /> {busy === "detect" ? "Caut…" : "Detectează telefonul meu"}
          </button>
          <button type="button" onClick={test} disabled={busy || !info.enabled} className="btn-ghost text-[13px] px-4 py-2 disabled:opacity-50" data-testid="telegram-test">
            <Send size={14} /> {busy === "test" ? "Se trimite…" : "Trimite test"}
          </button>
        </div>
        <p className="mt-3 text-[12px] text-[#6B7280]">Token-ul este păstrat securizat pe server și nu apare pe site.</p>
      </div>
      <ol className="lg:col-span-5 soft-card p-6 space-y-3 text-[13.5px] text-[#1A1A1A]">
        <div className="font-bold text-[#002B7F]">Cum configurezi (6 pași, ~3 minute)</div>
        {STEPS.map((s, i) => (
          <li key={s} className="flex gap-3"><span className="shrink-0 w-6 h-6 rounded-full bg-[#002B7F] text-white text-[12px] font-bold grid place-items-center">{i + 1}</span><span>{s}</span></li>
        ))}
      </ol>
    </div>
  );
};
